<div style="text-align:right;position:relative;z-index:3" *ngIf="!item.button_list">
  <p-button variant="text" severity="info" size="large" (click)="menu.toggle($event)" [disabled]="checkDisable()" aria-label="Data item menu">
  <i class="fas fa-bars"></i>
  </p-button>
  <p-menu #menu [model]="buttons" [popup]="true" [appendTo]="'body'"></p-menu>
</div>

<div class="scaffold-event-button" *ngIf="item.button_list" style="margin:0 10px;">
  <span>
    <p-button severity="info" variant="text" *ngFor="let option of buttons" (click)="execute(option.data)" [disabled]="checkDisable()" [style.display]="option.hidden ? 'none' : 'initial'">
      <i [class]="option.icon.pack + ' fa-' + option.icon.icon" *ngIf="option.data.use_icon" [pTooltip]="option.title || option.operation" attr.aria-label="{{option.title  || option.operation}}" [style]="'color:'+option.data.color|safeStyle"></i>
      <span *ngIf="!option.data.use_icon">{{option.translation_key||option.title| translation|translationFromString | transformText :option?.text_transform}}</span>
    </p-button>
  </span>
</div>
